import { BrowserModule } from "@angular/platform-browser";
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Inject,
  LOCALE_ID,
  NgModule,
} from "@angular/core";
import { HeaderComponent } from "@app/layouts/header/header.component";
import { BodyComponent } from "@app/layouts/body/body.component";
import { AppRoutingModule } from "@app/app-routing.module";
import { AuthLayoutComponent } from "@app/layouts/auth-layout/auth-layout.component";
import { AppComponent } from "@app/app.component";
import { NavComponent } from "@app/layouts/nav/nav.component";
import { DragulaModule } from "ng2-dragula";
import { CoreModule } from "@app/core/core.module";
import { DxSharedModule } from "@app/shared/dx-shared.module";
import { ngxLoadingAnimationTypes, NgxLoadingModule } from "ngx-loading";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { JwtModule } from "@auth0/angular-jwt";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  FaIconLibrary,
  FontAwesomeModule,
} from "@fortawesome/angular-fontawesome";
import { MetrikaModule } from "ng-yandex-metrika";
import { environment } from "@env/environment";
import "hammerjs";
import "mousetrap";
// Set locale according the browser language
import { loadMessages, locale } from "devextreme/localization";
import "./core/services/declarations.service";
import { ToastrModule } from "ngx-toastr";
import { BreadcrumbModule } from "params-xng-breadcrumb";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { UserResolver } from "@app/core/guards/user.resolver";
import {
  faAlignJustify,
  faAngleDoubleDown,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleDoubleUp,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faArrowCircleLeft,
  faArrowDown,
  faArrowRight,
  faArrowUp,
  faBars,
  faBomb,
  faBook,
  faBus,
  faCalendarDay,
  faCar,
  faCaretDown,
  faCaretRight,
  faCaretUp,
  faCarSide,
  faChartBar,
  faChartLine,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCloudDownloadAlt,
  faCloudUploadAlt,
  faCog,
  faCoins,
  faComment,
  faCommentAlt,
  faCommenting,
  faCopyright,
  faCross,
  faDoorOpen,
  faDownload,
  faDraftingCompass,
  faDrawPolygon,
  faEdit,
  faEraser,
  faExchangeAlt,
  faExclamationTriangle,
  faExternalLinkAlt,
  faFile,
  faFileCsv,
  faFileDownload,
  faFilter,
  faFolderOpen,
  faGlobe,
  faGlobeAmericas,
  faGripVertical,
  faHome,
  faHourglassStart,
  faImage,
  faImages,
  faInfo,
  faInfoCircle,
  faKey,
  faLanguage,
  faLightbulb,
  faLongArrowAltRight,
  faMagic,
  faMagnet,
  faMap,
  faMapMarkerAlt,
  faMinus,
  faMinusCircle,
  faObjectGroup,
  faPaintBrush,
  faPaperclip,
  faPencilAlt,
  faPlayCircle,
  faPlus,
  faPlusSquare,
  faPuzzlePiece,
  faReceipt,
  faRedo,
  faRoute,
  faSave,
  faSearch,
  faSpinner,
  faSquare,
  faStop,
  faStoreAlt,
  faStream,
  faSyncAlt,
  faTasks,
  faThList,
  faThumbTack,
  faTimes,
  faTools,
  faTrash,
  faUndo,
  faUpload,
  faUser,
  faUserCircle,
  faUserClock,
  faUserEdit,
  faUserFriends,
  faUserPlus,
  faUserSecret,
  faWalking,
  faWindowMinimize,
} from "@fortawesome/free-solid-svg-icons";

import {
  faCalendar,
  faCalendarCheck,
  faClock,
  faComments,
  faEye,
  faFileAlt,
  faFilePdf,
  faIdCard,
  faPaperPlane,
  faWindowMaximize,
} from "@fortawesome/free-regular-svg-icons";
import { PermissionsResolver } from "@app/core/guards";
import { YamapngModule } from "projects/yamapng/src/public_api";
import { YaCoreModule } from "projects/yamapng/src/lib/core.module";
import { GalleryModule } from "projects/ks89/angular-modal-gallery/src/public_api";
import { whitelistedDomains } from "@app/core/const";
// import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faCheckCircle as faCheckCircleReg } from "@fortawesome/free-regular-svg-icons/faCheckCircle";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons/faQuestionCircle";

import { faQrcode } from "@fortawesome/free-solid-svg-icons/faQrcode";
import { DOCUMENT, registerLocaleData } from "@angular/common";
import localeRu from "@angular/common/locales/ru";
import { ServiceWorkerModule } from "@angular/service-worker";
import {
  provideNgxWebstorage,
  withLocalStorage,
  withNgxWebstorageConfig,
  withSessionStorage,
} from "ngx-webstorage";
import { BackgroundModernComponent } from "@app/shared/components/background-modern/background-modern.component";
// import { SafeHtmlPipe } from "./core/pipes/safeHtml.pipe";
import { IconService } from "@app/core/services/icon.service";
import { MENU_ICON_PARTS } from "@app/core/const/menu-icons";
import { AuthModule } from "@app/modules/auth/auth.module";
import { OverlayModule } from "@angular/cdk/overlay";
import { NavBarComponent } from "@app/layouts/nav-bar/nav-bar.component";
import { DesignService } from "@app/core/services";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

const ruMessages = require("devextreme/localization/messages/ru.json");

// import { BrowserTransferStateModule } from '@angular/platform-browser';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
registerLocaleData(localeRu, "ru");

export function preloadIcons(iconService: IconService) {
  // Предзагрузка иконок с таймаутом для предотвращения зависания
  return () => {
    // Таймаут 3 секунды - если иконки не загрузились, приложение запустится без них
    const timeout = new Promise<void>((resolve) => setTimeout(resolve, 3000));
    const preload = iconService.preloadByPartsAsync(MENU_ICON_PARTS);

    // Возвращаем Promise.race - что завершится первым
    return Promise.race([preload, timeout]);
  };
}

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    HeaderComponent,
    NavComponent,
    BodyComponent,
    AuthLayoutComponent,
    BackgroundModernComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BreadcrumbModule,
    DragulaModule,
    BrowserAnimationsModule,
    CoreModule,
    DxSharedModule,
    GalleryModule,
    ToastrModule.forRoot({
      timeOut: 2000,
      positionClass: "toast-top-right",
    }),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.chasingDots,
      backdropBackgroundColour: "rgba(0,0,0,0.1)",
      backdropBorderRadius: "4px",
      primaryColour: "#7b7782",
      secondaryColour: "#b57a7c",
      tertiaryColour: "#6d2d28",
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return JSON.parse(
            localStorage.getItem("ngx-webstorage:access_token") || "null"
          ); //localStorage.getItem('access_token');
        },
        allowedDomains: whitelistedDomains,
        // disallowedRoutes: ['https://js.devexpress.com/'],
        authScheme: "",
      },
    }),
    FontAwesomeModule,
    MetrikaModule.forRoot(
      { id: 51418249, webvisor: environment.production } // CounterConfig | CounterConfig[]
    ),
    YamapngModule,
    YaCoreModule.forRoot({
      apiKey: "6dc6eebd-4766-439e-af89-6be9736df6f4",
    }),
    ToastrModule.forRoot({
      timeOut: 4000,
      positionClass: "toast-bottom-right",
      progressBar: true,
    }),
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: "registerWhenStable:30000",
    }),
    NgxSkeletonLoaderModule,
    AuthModule,
    OverlayModule,
    NavBarComponent,
    // SnowComponent,
    //NgxWebstorageModule,
  ],
  providers: [
    UserResolver,
    PermissionsResolver,
    // SafeHtmlPipe,
    { provide: LOCALE_ID, useValue: "ru" },
    provideNgxWebstorage(
      withNgxWebstorageConfig({ separator: ":", caseSensitive: true }),
      withLocalStorage(),
      withSessionStorage()
    ),
    // Preload main menu icons before app bootstraps to avoid icon popping
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: preloadIcons,
    //   deps: [IconService],
    //   multi: true,
    // },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    library: FaIconLibrary,
    private designService: DesignService,
    @Inject(DOCUMENT) private document: Document
  ) {
    library.addIcons(
      faPaperPlane,
      faMap,
      faUndo,
      faRedo,
      faAngleDoubleLeft,
      faAngleDoubleRight,
      faAngleDoubleDown,
      faAngleDoubleUp,
      faAngleDown,
      faAngleLeft,
      faAngleRight,
      faPlusSquare,
      faMinusCircle,
      faAngleUp,
      faPencilAlt,
      faBars,
      faUserSecret,
      faArrowUp,
      faArrowDown,
      faSpinner,
      faDoorOpen,
      faInfo,
      faInfoCircle,
      faChevronDown,
      faChevronUp,
      faChevronRight,
      faChevronLeft,
      faCircle,
      faCalendar,
      faCalendarDay,
      faTrash,
      faEye,
      faHourglassStart,
      faUserFriends,
      faFileCsv,
      faFileDownload,
      faDownload,
      faExchangeAlt,
      faFile,
      faFileAlt,
      faSave,
      faSyncAlt,
      faIdCard,
      faUserEdit,
      faStoreAlt,
      faCross,
      faMagic,
      faGlobeAmericas,
      faCoins,
      faUser,
      faUserClock,
      faTimes,
      faCar,
      faClock,
      faLongArrowAltRight,
      faWindowMaximize,
      faWindowMinimize,
      faDrawPolygon,
      faGlobe,
      faDraftingCompass,
      faCloudDownloadAlt,
      faArrowRight,
      faCopyright,
      faBomb,
      faExclamationTriangle,
      faCheckDouble,
      faCheckCircleReg,
      faEdit,
      faHome,
      faChartPie,
      faThList,
      faUserCircle,
      faRoute,
      faMapMarkerAlt,
      faPuzzlePiece,
      faPlayCircle,
      faPlus,
      faUserPlus,
      faQrcode,
      faTimes,
      faCaretUp,
      faCaretDown,
      faChartLine,
      faChartBar,
      faCalendarCheck,
      faFilter,
      faTasks,
      faCheck,
      faSquare,
      faLanguage,
      faPaintBrush,
      faLightbulb,
      faWindowMaximize,
      faStream,
      faBook,
      faMinus,
      faEraser,
      faCog,
      faGripVertical,
      faKey,
      faFolderOpen,
      faImages,
      faImage,
      faComments,
      faExternalLinkAlt,
      faAlignJustify,
      faCarSide,
      faWalking,
      faBus,
      faCheckCircle,
      faTimesCircle,
      faQuestionCircle,
      faReceipt,
      faCloudUploadAlt,
      faFilePdf,
      faUpload,
      faFilePdf,
      faCaretRight,
      faCaretDown,
      faObjectGroup,
      faMagnet,
      faArrowAltCircleLeft,
      faArrowAltCircleRight,
      faThumbTack,
      faExchangeAlt,
      faComment,
      faCommentAlt,
      faSearch,
      faTools,
      faPaperclip,
      faArrowCircleLeft,
      faStop,
      faCommenting
    );
    loadMessages(ruMessages);
    locale(navigator.language);

    // обновление favicon в зависимости от выбранного дизайна
    this.designService.design$.pipe(takeUntilDestroyed()).subscribe((design) => {
      let link: HTMLLinkElement = this.document.querySelector("link[rel~='icon']");

      if (!link) {
        link = this.document.createElement("link");
        link.rel = "icon";
        this.document.head.appendChild(link);
      }

      if (design === "classic") {
        link.href = "favicon.ico";
      } else {
        link.href = "assets/favicon-modern/favicon.ico";
      }
    })
  }
}
